import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import Link from 'next/link';
import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import Text from '@/shared/Typography/Text';
import { Check } from '@styled-icons/boxicons-regular';
import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import ProgressFeedback from '@/shared/ProgressFeedback/ProgressFeedback';
import { getLevelLabel } from '@/constants/ActivityLevelLabels';
import { Tag, Tooltip } from 'antd';
import { isTaskActivityDone } from '@/modules/tasks/isTaskActivityDone';
import { StyledTaskActivityNavLink } from './TaskActivityNavLink.styled';

export default function TaskActivityNavLink({
  taskActivity,
  isCurrent,
  feedbackParams,
  href,
  onClick,
  locked,
}) {
  const content = (
    <>
      <div className="left">
        {isTaskActivityDone(taskActivity.activityProgress) ? (
          <div className="done-icon">
            <Check size={pxToVw(30)} />
          </div>
        ) : (
          <ActivityTypeIcon
            type={taskActivity.activity.type}
            color="white"
            circleColor={Colors.activityTypeColors[taskActivity.activity.type]}
            withCircle
            size={pxToVw(15)}
            width={pxToVw(46)}
            height={pxToVw(46)}
          />
        )}
        <Text className={`activity-type-name ${isCurrent ? 'active' : ''}`}>
          {typeLabel(
            taskActivity.activity.type,
            taskActivity.activity.data.subType,
            taskActivity.activityConf.miniactivityType
          )}
          {taskActivity.activityConf.options?.level ? (
            <Tag>{getLevelLabel(taskActivity.activityConf.options.level)}</Tag>
          ) : null}
        </Text>
      </div>
      <div className="right">
        {taskActivity.activityConf.progress ? (
          <ProgressFeedback
            repetitions={taskActivity.activityConf.options?.repetitions}
            activityProgress={taskActivity.activityProgress}
            showCorrect={taskActivity.activityConf.correctness}
            dueDate={feedbackParams.dueDate}
            timeOffset={feedbackParams.timeOffset}
            isStudent
            onlyGraph
            size="small"
          />
        ) : null}
      </div>
    </>
  );

  if (locked) {
    return (
      <Tooltip title="Complete the other activities first" placement="left">
        <StyledTaskActivityNavLink as="div" className="locked">
          {content}
        </StyledTaskActivityNavLink>
      </Tooltip>
    );
  }

  return (
    <Link href={href} passHref legacyBehavior>
      <StyledTaskActivityNavLink
        className={isCurrent ? 'current' : ''}
        onClick={onClick}
      >
        {content}
      </StyledTaskActivityNavLink>
    </Link>
  );
}
